import React from 'react';
import SandboxedContent from '../../../../../SandboxedContent/SandboxedContent';

function ScheduleItemDescription(props) {
    const { session } = props,
        { description } = session;

    if (!description) return null;

    return (
        <div className="content">
            <SandboxedContent content={session.description} fitHeightToContents noInnerPadding />
        </div>
    );
}

export default ScheduleItemDescription;
